import type { ReviewCard, ReviewState } from "./ggb-review.js";
import { validateImportedPlayerScores } from "../../../../domain/imported-round/imported-totals-validation.js";

export function reviewedTotals(card: ReviewCard) {
  const number = (value: string | undefined) =>
    value?.trim() ? Number(value) : null;
  return {
    gross: number(card.totals?.gross),
    net: number(card.totals?.net),
    stableford: number(card.totals?.stableford),
  };
}
export function validateTotalsReview(
  review: ReviewState,
  cards: ReviewCard[],
): string | null {
  if (review.format === "match-play")
    return "A Match Play result cannot be inferred from total strokes. Use its actual hole-by-hole card.";
  if (!review.holeCount || ![9, 18].includes(review.holeCount))
    return "Confirm whether the totals cover nine or eighteen holes.";
  for (const card of cards) {
    if (card.assign === "__guest__" && (!card.named || !card.name.trim()))
      return "Enter the new guest's name.";
    if (
      card.playingHandicap &&
      (!/^-?\d+$/.test(card.playingHandicap) ||
        Number(card.playingHandicap) < -20 ||
        Number(card.playingHandicap) > 100)
    )
      return `${card.name}: enter the reported PH, or leave it unknown.`;
    if (
      Object.values(card.totals ?? {}).some(
        (value) => value.trim() && !/^-?\d+$/.test(value),
      )
    )
      return `${card.name}: enter actual integer totals, or leave unknown totals blank.`;
    try {
      validateImportedPlayerScores(
        reviewedTotals(card),
        review.format,
        review.scoringBasis,
      );
    } catch (error) {
      return `${card.name}: ${error instanceof Error ? error.message : "Check the recorded totals."}`;
    }
  }
  return null;
}

export function newTotalsCard(index: number): ReviewCard {
  return {
    key: `totals-${index}`,
    name: `Player ${index + 1}`,
    named: false,
    hcp: null,
    assign: "",
    scores: {},
    conf: {},
    teeName: "",
    playingHandicap: "",
    par: {},
    si: {},
    reconstructed: [],
    totals: { gross: "", net: "", stableford: "" },
  };
}
